import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Popover, Button } from '@patternfly/react-core';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../localization/useTranslation';
import styles from './ColorPicker.module.css';
import { defaultColors } from '../../../utils/colors';
import _ from 'lodash';

const ColorButton = ({ color, onClick }) => {

  return (
    <Button
      key={color}
      className="picker__swatch"
      style={{ background: color }}
      onClick={onClick}
    />

  );
};

const ColorPicker = ({ value, onChange, palette = defaultColors, appendTo }) => {
  const T = useTranslation();
  const [customColors, setCustomColors] = useState([]);

  useEffect(() => {
    setCustomColors(JSON.parse(localStorage.getItem('color-picker-custom-colors') || '[]'));
  }, []);

  const debouncedFunc = useMemo(() => _.debounce((newColor) => onChange(newColor), 200), [onChange]);

  useEffect(() => {
    return () => debouncedFunc.cancel();
  }, [debouncedFunc]);

  const updateColor = useCallback((color) => {
    debouncedFunc(color);
  }, [debouncedFunc]);

  const handleAddCustomColor = useCallback((color) => {
    const newColors = [
      ...customColors,
      color
    ];

    localStorage.setItem('color-picker-custom-colors', JSON.stringify(newColors));
    setCustomColors(newColors);
  }, [customColors]);

  return (
    <Popover
      appendTo={appendTo}
      bodyContent={
        <div className={styles.picker}>
          <HexColorPicker
            color={value}
            onChange={updateColor}
          />

          <div className={styles.picker__container}>
            <HexColorInput color={value} onChange={updateColor} />
          </div>

          <div className={styles.picker__container}>
            <Button isBlock variant="secondary" onClick={() => handleAddCustomColor(value)}>{ T.colorPicker.addCustomColor }</Button>
          </div>
          <div className={styles.picker__container}>
            { T.colorPicker.defaultColors }
          </div>
          <div className={styles.picker__swatches}>
            { _.map(palette, (color, key) => (<ColorButton key={key} color={color} onClick={() => updateColor(color)} />)) }
          </div>

          <div className={styles.picker__container}>
            { T.colorPicker.customColor }
          </div>
          <div className={styles.picker__swatches}>
            { _.map(customColors, (color, key) => (<ColorButton key={key} color={color} onClick={() => updateColor(color)} />)) }
          </div>
        </div>
      }
    >
      <Button
        style={{
          backgroundColor: value,
          height: '28px',
          width: '28px'
        }}
      />
    </Popover>
  );
};

ColorPicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  appendTo: PropTypes.func
};

export default React.memo(ColorPicker);
